import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'ngx-generic-spinner',
  templateUrl: './generic-spinner.component.html',
  styleUrls: ['./generic-spinner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class GenericSpinnerComponent {
  @Input() diameter = '';
}
